const PieChartIcon = ({ className }: { className?: string }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M4.89278 2.95941C6.2187 1.9035 7.81582 1.24343 9.50034 1.05518V11.0002H19.4453C19.2571 12.6847 18.597 14.2818 17.5411 15.6077C16.4852 16.9337 15.0763 17.9345 13.4767 18.495C11.8771 19.0556 10.1517 19.1531 8.4991 18.7763C6.84651 18.3995 5.3339 17.5637 4.13536 16.3652C2.93681 15.1666 2.10104 13.654 1.72425 12.0014C1.34745 10.3488 1.44493 8.62343 2.00548 7.0238C2.56603 5.42417 3.56685 4.01533 4.89278 2.95941Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5003 7.00018H18.9883C18.5394 5.73479 17.8138 4.58552 16.8644 3.63611C15.915 2.68671 14.7657 1.9611 13.5003 1.51218V7.00018Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PieChartIcon;
